import { render, staticRenderFns } from "./ZawaSuspended.vue?vue&type=template&id=a9955794&scoped=true"
import script from "./ZawaSuspended.vue?vue&type=script&lang=ts"
export * from "./ZawaSuspended.vue?vue&type=script&lang=ts"
import style0 from "./ZawaSuspended.vue?vue&type=style&index=0&id=a9955794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9955794",
  null
  
)

export default component.exports